// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3l6-9","messages":"Chat_messages__3B4IA","dateDivider":"Chat_dateDivider__3-GUm"};